import React from "react";
import styled from "styled-components";
import GraphIcon from '../../../../components/icons/GraphIcon';

export const Wrapper = styled.div`
  @media not print {
    .sidebar-wrapper {
      background: #e6e6e6;
      border-left: 1px solid #c3c3c3;
      display: flex;
      flex-direction: column;
      height: 100%;
      position: absolute;
      left: 0;
      transition: all 0.1s;
      width: 350px;
      z-index:1000;
    }
  }

  &.hide {
    .sidebar-wrapper {
      width: 0;
      border: none;
    }

    .sidebar {
      overflow: hidden;
    }
  }

  .sidebar {
    overflow-x: hidden;
    height: 100%;
    position: relative;

    .close-button {
      position: absolute;
      top: 17px;
      left: 10px;
    }

    .header {
      font-size: 20px;
      padding: 28px;
      padding-left: 60px;
      border-bottom: 1px solid #c3c3c3;
    }

    .content {
      padding: 0 28px;
    }

    .label {
      margin-top: 28px;
      margin-bottom: 7px;
      text-transform: uppercase;
      font-size: 12px;
      font-family: Roboto;
      font-weight:bold;
      line-height: 1.42;
      letter-spacing: -0.08px;
      color: #212121;      
    }

    .sub {
      margin-top: 7px;
      margin-left: 25px;
    }

    // .label,
    // .ui.checkbox,
    // .ui.dropdown {
    //   min-width: 243px;
    // }

    .filters {
      margin-top: 2rem;
      border: 1px solid lightgrey;
      border-radius: 5px;
      padding: 1rem;
      position: relative;

      h3 {
        background-color: #e6e6e6;
        display: inline-block;
        position: absolute;
        top: -10px;
        padding: 0 1rem;
      }

      .ui.dropdown {
        width:100%;
        min-width:inherit;
      }

      button {
        margin-top:1rem;
      }

      .ui.tertiary {
        color: #026d94;
        background: transparent;
      }

      .ui.editfilters {
        margin: 2px;
        padding: 0;
        float: right;
      }

      .ui.clearfilters {
        display:block;
        padding:0;
        margin-top:1rem;
        font-weight:normal;
        visibility:hidden;

        &.available {
          visibility: visible;
        }

      }
    }
  }

  .toggle {
    position: fixed;
    top: 90px;
    left: 90px;
    cursor: pointer;
    transition: all 0.1s ease-out;
    user-select: none;
    display:none;

    @media only screen and (max-width: 1230px) { 
      display:none;
    }

    padding: 9px 15px;
    border-radius: 5px;
    background-color: #e0e0e0;    

    &:hover {
      color: #084a65;
      // transition: all 0.2s ease-out;
      // border-radius:1px;
      background-color:#dbdbdb;

      i {
        //transform: translateX(0);
        //opacity: 0.99;
        //transition: all 0.2s ease-out;
      }
    }

    i {
      // transform: translateX(10px);
      // opacity: 0;
      font-size: 16px !important;
      color: #999999;
      //transition: all 0.1s ease-out;
    }

    span {
      font-size: 14px !important;
      font-family: Roboto; 
      font-size: 14px; 
      color: #999999;
    }
  }

  @media print {
    display: none;
  }
`;

export const BenchmarkContainer = styled.div`
  display: flex;
  padding-bottom: 50px;

  && {
    p {
      font-size: 13px;
      margin-bottom: 8px;
      font-family: Roboto,'Helvetica Neue',Arial,Helvetica,sans-serif !important; 
    }
  
    .Mui-checked {
      color: ${props => props.theme.primary};
    }

    .MuiFormGroup-root {
      padding-left: 15px;
    }
  }
`;

export const BenchmarkIcon = styled((props) => <GraphIcon {...props}/>)`
  font-size: 13px !important;
  margin-right: 6px;
  margin-top: 28px;
  color: ${props => props.theme.primary};
`;



// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/Sidebar/style.js